<template>
  <div class="table-section">
    <div class="row">
      <div class="col-12">
<!--        <SearchCustomerAccountForm />-->
<SearchCustomerUpgradeForm/>
      </div>
    </div>
    <div class="table-top">
      <b-row>
        <b-col md="4" lg="4" class="my-1">
          <p class="table-filter text-left">
            <BaseInput
              type="text"
              label="Search"
              :inputType="'text'"
              v-model="filter"
              placeholder="Search something..."
              :hasPreIcon="false"
            >
            </BaseInput>
          </p>
        </b-col>
        <b-col md="8" lg="8" class="my-1">
          <p class="table-action text-right">
            <span v-if="customer.upgradeLogsLoader" class="formLoaderHold">
                <BaseComponentLoader />
              </span>
            <span v-else class="excel-download-btn-hold">
              <button
                type="button"
                class="btn btn-secondary btn-semi-rounded mb-2 mr-2"
              >
                <i class="bx bxs-report"></i> &nbsp; &nbsp;
                <download-excel
                  class="excel-download-btn"
                  :data="items"
                  :fields="json_fields"
                  worksheet="My Worksheet"
                  name="filename.xls"
                >
                  Download As Excel
                </download-excel>
              </button>
            </span>
          </p>
        </b-col>
      </b-row>
    </div>
    <b-table
      striped
      hover
      :fields="fields"
      :items="items"
      :busy="isBusy"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
      responsive="sm"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filterIncludedFields="filterOn"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <!-- A virtual column -->
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <!-- A virtual composite column -->
      <template v-slot:cell(customerBankCode)="data">
        <p class="name-field">
          <span>{{ data.item.customerBankCode }}</span>
        </p>
      </template>

      <template v-slot:cell(accountBalance)="data">
        <p class="name-field">
          <span> ₦ {{ data.item.accountBalance | formatAmount }} </span>
        </p>
      </template>

      <template v-slot:cell(accountLedgerBalance)="data">
        <p class="name-field">
          <span> ₦ {{ data.item.accountLedgerBalance | formatAmount }} </span>
        </p>
      </template>

      <!-- A virtual composite column -->
      <template v-slot:cell(accountCreatedDate)="data">
        <p class="name-field">
          <span>
            {{ data.item.accountCreatedDate | formatDateForTable }}
          </span>
        </p>
      </template>

      <!-- A virtual composite column -->
      <template v-slot:cell(accountLastAccessTimestamp)="data">
        <p class="name-field">
          <span>
            {{ data.item.accountLastAccessTimestamp | formatDateForTable }}
          </span>
        </p>
      </template>

      <template v-slot:cell(accountClass)="data">
        <p class="name-field">
          <span class="badge badge-pill badge-soft-secondary font-size-12">
            {{ data.item.accountClass }}
          </span>
        </p>
      </template>

      <template v-slot:cell(accountType)="data">
        <p class="name-field">
          <span class="badge badge-pill badge-soft-secondary font-size-12">
            {{ data.item.accountType }}
          </span>
        </p>
      </template>

      <template v-slot:cell(accountCurrency)="data">
        <p class="name-field">
          <span class="badge badge-pill badge-soft-secondary font-size-12">
            {{ data.item.accountCurrency }}
          </span>
        </p>
      </template>

      <template v-slot:cell(accountStatus)="data">
        <p class="name-field">
          <AppStatusBadge :status-value="data.item.accountStatus" />
        </p>
      </template>

      <!-- A virtual composite column -->
      <template v-slot:cell(action)="data">
        <b-dropdown
          class="card-drop"
          variant="white"
          dropleft
          toggle-class="p-0"
          @hidden="resetDropdown"
        >
          <template v-slot:button-content>
            <i class="mdi mdi-eye font-size-18"></i>
          </template>
          <b-dropdown-item @click="viewCustomer(data.item)">
            <i class="bx bx-list-ul text-danger mr-1"></i> View
          </b-dropdown-item>
        </b-dropdown>
        <CustomerUpgradeData
          :current-customer="data.item"
          v-if="showCustomerComponent"
        />
      </template>

      <!-- Optional default data cell scoped slot -->
      <template v-slot:cell()="data">
        <i>{{ data.value }}</i>
      </template>
    </b-table>
    <b-row>
      <b-col sm="5" md="4" class="my-1">
        <b-form-group
          label="Per page"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="perPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="8" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import SearchCustomerAccountForm from "../../Forms/Customer/SearchCustomerAccountForm";
import CustomerUpgradeData from "../../../../views/Customer/CustomerUpgradeData";
import SearchCustomerUpgradeForm from "../../Forms/Customer/SearchCustomerUpgradeForm";

export default {
  name: "AllCustomerTable",
  components: {SearchCustomerUpgradeForm, CustomerUpgradeData },
  data() {
    return {
      sortBy: "date",
      sortDesc: false,
      showCustomerComponent: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      // Note 'isActive' is left out and will not appear in the rendered table
      fields: [
        // A virtual column that doesn't exist in items
        { key: "index", label: "S/N", sortable: true, class: "text-center" },
        { key: "firstName", label: "First Name", sortable: true },
        { key: "lastName", label: "Last Name", sortable: true },
        { key: "middleName", label: "Middle Name", sortable: true },
        { key: "phoneNumber", label: "Phone Number", sortable: true },
        { key: "bvn", label: "BVN", sortable: true },
        { key: "detailsVerified", label: "Details Verified", sortable: true },
        { key: "logoVerified", label: "Logo Verified", sortable: true },
        { key: "dobVerified", label: "DOB Verified", sortable: true },
        { key: "bvnVerified", label: "BVN Verified", sortable: true },
        { key: "pictureVerified", label: "Picture Verified", sortable: true },
        {
          key: "utilityBillVerified",
          label: "Utility Bill Verified",
          sortable: true
        },
        {
          key: "signatureVerified",
          label: "Signature Verified",
          sortable: true
        },
        { key: "addressVerified", label: "Address Verified", sortable: true },
        { key: "idCardVerified", label: " ID Card Verified", sortable: true },
        { key: "cacVerified", label: "CAC Verified", sortable: true },
        { key: "action", label: "Action", sortable: false }
        // { key: "action", label: "Action", sortable: false }
      ],

      json_fields: {
        accountChecker: "accountChecker",
        accountBankCode: "accountBankCode",
        accountUpdatedDate: "accountUpdatedDate",
        accountGlLevel1Code: "accountGlLevel1Code",
        accountName: "accountName",
        accountInterestRate: "accountInterestRate",
        accountType: "accountType",
        accountAllowNegativeBalance: "accountAllowNegativeBalance",
        accountCurrency: "accountCurrency",
        accountNumber: "accountNumber",
        accountLastAccessTimestamp: "accountLastAccessTimestamp",
        accountDateClosed: "accountDateClosed",
        accountGlCategory: "accountGlCategory",
        accountBranchCode: "accountBranchCode",
        accountStatus: "accountStatus",
        accountMaker: "accountMaker",
        accountId: "accountId",
        accountCreatedDate: "accountCreatedDate",
        accountCustomerId: "accountCustomerId",
        accountClass: "accountClass",
        accountLedgerBalance: "accountLedgerBalance",
        accountGlLevel2Code: "accountGlLevel2Code",
        accountBalance: "accountBalance",
        accountDateOpened: "accountDateOpened"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ]
    };
  },
  computed: {
    ...mapState({
      items: state => state.customer.allLogs,
      isBusy: state => state.customer.upgradeLogsLoader,
      customer: state => state.customer
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.filter = " ";
  },
  methods: {
    viewCustomer(customerData) {
      this.showCustomerComponent = true;
      this.$router.push({
        name: "customer-upgrade-data",
        params: { currentCustomer: customerData }
      });
    },
    resetDropdown() {
      // Reset the dropdown state when it's hidden (i.e., closed)
      this.showCustomerComponent = false;
    },
    returnItems() {},
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getInitials(_name) {
      let parts = _name.split(" ");
      let initials = "";
      for (let i = 0; i < parts.length; i++) {
        if (parts[i].length > 0 && parts[i] !== "") {
          initials += parts[i][0];
        }
      }
      if (initials.length === 2) {
        return initials;
      } else if (initials.length < 2) {
        initials = initials + initials;
        return initials;
      } else {
        return initials.substring(0, 2);
      }
    },
    fetchTableData() {
      const payload = {
        readAll: "YES"
      };
      this.$store.dispatch("customer/allLogsUpgrade", payload, {
        root: true
      });
    }
  },
  created() {
    this.fetchTableData();
  }
};
</script>
<style scoped>
/*.VueTables__date-filter {*/
/*  border: 1px solid #ccc;*/
/*  padding: 6px;*/
/*  border-radius: 4px;*/
/*  cursor: pointer;*/
/*}*/
.view-more-info {
  margin-right: 2px;
  display: inline-block;
  color: #ffffff;
}
.view-more-info a {
  cursor: pointer;
}
.view-more-info a i {
  cursor: pointer;
}
.actual-name {
  margin-left: 2px;
  line-height: 15px;
}
</style>
